import { css, styled } from 'styled-components';

export const ProjectBrandYear = styled.div<{ isDisplayView?: boolean }>`
  ${({ isDisplayView = false }) => css`
    display: flex;
    margin-bottom: 20px;

    ${isDisplayView &&
    css`
      align-items: center;
      flex-wrap: wrap;
      margin-top: -16px;

      & > * {
        margin-top: 16px;
        margin-right: 16px;
      }
    `}
  `}
`;
